'use client'

import { memo } from 'react'
import type { ActivityLogEntry } from './ActivityLog'

// ============================================================================
// Types
// ============================================================================

interface LogEntryProps {
  entry: ActivityLogEntry
  onClick?: (taskId: string) => void
}

// ============================================================================
// Component
// ============================================================================

export const LogEntry = memo(function LogEntry({
  entry,
  onClick
}: LogEntryProps) {

  const typeConfig = {
    task_created: {
      icon: '📝',
      color: 'text-blue-400',
      bgColor: 'bg-blue-500/10'
    },
    task_started: {
      icon: '🔄',
      color: 'text-yellow-400',
      bgColor: 'bg-yellow-500/10'
    },
    task_completed: {
      icon: '✅',
      color: 'text-green-400',
      bgColor: 'bg-green-500/10'
    },
    task_error: {
      icon: '❌',
      color: 'text-red-400',
      bgColor: 'bg-red-500/10'
    },
    task_review: {
      icon: '📋',
      color: 'text-purple-400',
      bgColor: 'bg-purple-500/10'
    },
    task_approved: {
      icon: '✅',
      color: 'text-green-400',
      bgColor: 'bg-green-500/10'
    },
    task_rejected: {
      icon: '🚫',
      color: 'text-red-400',
      bgColor: 'bg-red-500/10'
    }
  }

  const config = typeConfig[entry.type]

  const formatTime = (date: Date) => {
    return date.toLocaleTimeString('pt-BR', {
      hour: '2-digit',
      minute: '2-digit',
      second: '2-digit'
    })
  }

  const handleClick = () => {
    onClick?.(entry.taskId)
  }

  const prioridade = entry.metadata?.prioridade
  const showPrioridade = prioridade != null

  return (
    <div
      className={`group flex items-start gap-3 px-3 py-2 rounded hover:bg-gray-800 transition-colors cursor-pointer ${config.bgColor}`}
      onClick={handleClick}
    >
      {/* Timestamp */}
      <span className="text-gray-500 text-xs shrink-0 w-20">
        {formatTime(entry.timestamp)}
      </span>

      {/* Icon */}
      <span className="shrink-0 text-sm">
        {config.icon}
      </span>

      {/* Type */}
      <span className={`${config.color} shrink-0 w-24 text-xs uppercase font-semibold`}>
        {entry.type.replace('task_', '')}
      </span>

      {/* Message */}
      <span className="flex-1 text-gray-300 text-xs">
        {entry.message}
      </span>

      {/* Task ID */}
      <span className="text-gray-600 text-xs font-mono shrink-0 opacity-0 group-hover:opacity-100 transition-opacity">
        [{entry.taskId.slice(0, 8)}]
      </span>

      {/* Metadata */}
      {/* Temporariamente desabilitado devido a erro de tipo TypeScript */}
      {/* {showPrioridade && (
        <span className="text-gray-600 text-xs shrink-0 opacity-0 group-hover:opacity-100 transition-opacity">
          P{prioridade}
        </span>
      )} */}
    </div>
  )
})
